<template>
  <div class="p15 bacf borr10">
    <div class="fontw font16">热门搜索</div>
    <!-- @click="detail(item.guid)" -->
    <div v-for="(item, index) in newList" :key="index" class="mt15">
      <p class="overh newTitle curp" @click="changeTitle(item.questiontitle)">
        <span :class="'number num' + (index + 1)">{{ index + 1 }}</span>
        <span>{{ item.questiontitle }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newList: [
        {
          questiontitle: "招标流程中涉及的法律风险如何防范？",
        },
        {
          questiontitle: "招标文件中应包含哪些关键内容？",
        },
        {
          questiontitle: "如何处理投标人的疑问和异议？",
        },
        {
          questiontitle: "如何应对投标过程中的违规行为？",
        },
        {
          questiontitle: "如何理解和应用最新的招标法规？",
        },
      ],
    };
  },
  mounted() {
    //this.getList()
  },
  methods: {
    getList() {
      var that = this;
      this.$get(
        `${this.$store.state.api.webUrl}/question/hotsearchlist.json`,
        {
          limit: 5,
        },
        (data) => {
          that.newList = data;
        }
      );
    },
    detail(guid) {
      this.$router.push({
        path: "/everydayQuestion/questionInfo?guid=" + guid,
      });
    },

    //修改热搜
    changeTitle(title) {
      this.$emit("getTitle", title);
    },
  },
};
</script>

<style scoped>
.newTitle:hover {
  color: #409eff;
}
.number {
  font-weight: bold;
  color: #9498a6;
}
.num1 {
  color: #fe4b60;
}
.num2 {
  color: #ff6600;
}
.num3 {
  color: #faab13;
}
/* .num4,.num5{
        color: #9498a6;
    } */
</style>
